import React from 'react'

export default function ResetIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
      <path d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z" stroke="black" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M4.22742 6.7832L6.773 4.23762" stroke="black" strokeWidth="0.8" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M6.773 6.76238L4.22742 4.2168" stroke="black" strokeWidth="0.8" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
